import { createStore } from "vuex";
import axios from "axios";

export default createStore({
  state: {
    user: null,
    token: null,
    permissions: [],
    advertisement: null
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    },
    setPermissions(state, permissions) {
      state.permissions = permissions;
    },
    setAdvertisement(state, advertisement) {
      state.advertisement = advertisement;
    },
    setUserData(state, payload) {
      state.userData = payload
    }
  },
  actions: {
    async postLogin({ commit }, { email, password }) {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_URL_API}/auth`,
          {
            email,
            password,
          }
        );

        const { user, token, advertisement } = response.data;
        const permissionIdentifiers = user.permissions.map(p => p.identifier);

        commit('setUser', user);
        commit('setToken', token);
        commit('setPermissions', permissionIdentifiers);
        commit('setAdvertisement', advertisement);

        localStorage.setItem('userData', JSON.stringify(response.data));

        return response.data
      } catch (error) {
        throw error;
      }
    },
    initializeStore({ commit }) {
      const userData = localStorage.getItem('userData');
      if (userData) {
        const parsedData = JSON.parse(userData);
        commit('setUser', parsedData.user);
        commit('setToken', parsedData.token);
        commit('setAdvertisement', parsedData.advertisement);
        const permissionIdentifiers = parsedData.user.permissions.map(p => p.identifier);
        commit('setPermissions', permissionIdentifiers);
      }
    },
    saveAdvertisementToLocalStorage({ commit }, advertisement) {
      const stored = localStorage.getItem('userData');
      let data = stored ? JSON.parse(stored) : {};
      data.user.advertisement = advertisement;
      localStorage.setItem('userData', JSON.stringify(data));
      commit('setAdvertisement', advertisement);
    }

  },
  getters: {
    getUser: (state) => state.user,
    getToken: (state) => state.token,
    getPermissions: (state) => state.permissions,
    getAdvertisement: (state) => state.advertisement,
  },
  modules: {},
});